export const GET_AUTOPARK_INFO = 'autoparks-modal/GET_AUTOPARK_INFO';
export const getAutoparkInfoAction = payload => ({
	type: GET_AUTOPARK_INFO,
	payload,
});

export const SET_AUTOPARK_INFO = 'autoparks-modal/SET_AUTOPARK_INFO';
export const setAutoparkInfoAction = payload => ({
	type: SET_AUTOPARK_INFO,
	payload,
});

export const SET_IS_AUTOPARK_INFO_LOADING = 'autoparks-modal/SET_IS_AUTOPARK_INFO_LOADING';
export const setIsAutoparkInfoLoadingAction = payload => ({
	type: SET_IS_AUTOPARK_INFO_LOADING,
	payload,
});

export const GET_AUTOPARK_COMPANIES_LIST = 'autoparks-modal/GET_AUTOPARK_COMPANIES_LIST';
export const getAutoparkCompaniesListAction = payload => ({
	type: GET_AUTOPARK_COMPANIES_LIST,
	payload,
});

export const SET_AUTOPARK_COMPANIES_LIST = 'autoparks-modal/SET_AUTOPARK_COMPANIES_LIST';
export const setAutoparkCompaniesListAction = payload => ({
	type: SET_AUTOPARK_COMPANIES_LIST,
	payload,
});

export const SET_IS_AUTOPARK_COMPANIES_LIST_LOADING = 'autoparks-modal/SET_IS_AUTOPARK_COMPANIES_LIST_LOADING';
export const setIsAutoparkCompaniesListLoadingAction = payload => ({
	type: SET_IS_AUTOPARK_COMPANIES_LIST_LOADING,
	payload,
});

export const CREATE_AUTOPARK = 'autoparks-modal/CREATE_AUTOPARK';
export const createAutoparkAction = payload => ({
	type: CREATE_AUTOPARK,
	payload,
});

export const SET_IS_AUTOPARK_CREATING = 'autoparks-modal/SET_IS_AUTOPARK_CREATING';
export const setIsAutoparkCreatingAction = payload => ({
	type: SET_IS_AUTOPARK_CREATING,
	payload,
});

export const UPDATE_AUTOPARK = 'autoparks-modal/UPDATE_AUTOPARK';
export const updateAutoparkAction = payload => ({
	type: UPDATE_AUTOPARK,
	payload,
});

export const SET_IS_AUTOPARK_UPDATING = 'autoparks-modal/SET_IS_AUTOPARK_UPDATING';
export const setIsAutoparkUpdatingAction = payload => ({
	type: SET_IS_AUTOPARK_UPDATING,
	payload,
});

export const DELETE_AUTOPARK = 'autoparks-modal/DELETE_AUTOPARK';
export const deleteAutoparkAction = payload => ({
	type: DELETE_AUTOPARK,
	payload,
});

export const SET_IS_AUTOPARK_DELETING = 'autoparks-modal/SET_IS_AUTOPARK_DELETING';
export const setIsAutoparkDeletingAction = payload => ({
	type: SET_IS_AUTOPARK_DELETING,
	payload,
});

export const RESET_STATE = 'autoparks-modal/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});
